import { action, observable, runInAction } from 'mobx';
import { PasswordStore } from 'ui/base/input';
import { IAccountsDomain } from 'services/accounts/types';
import * as UserService from 'services/accounts/user_service';
import { ResultKind } from 'services/base/types';
import { BusyStore } from 'ui/base/button';

export class ChangePasswordStore {
  readonly oldPassword: PasswordStore;
  readonly newPassword: PasswordStore;
  readonly confirmPassword: PasswordStore;

  @observable.ref
  oldPasswordError: string | undefined;

  @observable.ref
  newPasswordError: string | undefined;

  @observable.ref
  confirmPasswordError: string | undefined;

  @observable.ref
  busy: BusyStore;

  constructor() {
    this.oldPassword = new PasswordStore('');
    this.newPassword = new PasswordStore('');
    this.confirmPassword = new PasswordStore('');
    this.busy = new BusyStore();
  }

  @action.bound
  async handleSave(domain: IAccountsDomain): Promise<UserService.PatchResult> {
    this.oldPasswordError = undefined;
    this.newPasswordError = undefined;
    this.confirmPasswordError = undefined;

    const result = await UserService.patch({
      domain,
      oldPassword: this.oldPassword.value,
      password: this.newPassword.value,
      confirmPassword: this.confirmPassword.value,
    });
    return runInAction(() => {
      if (result.kind === ResultKind.USER_ERROR) {
        this.oldPasswordError = result.oldPasswordError;
        this.newPasswordError = result.passwordError;
        this.confirmPasswordError = result.confirmPasswordError;
      }
      return result;
    });
  }
}